if (!customElements.get('banner-carousel')) {
  customElements.define(
    'banner-carousel',
    class BannerCarousel extends HTMLElement {
      connectedCallback() {
        const container = this.querySelector('.banner-carousel__swiper');
        if (!container || typeof Swiper === 'undefined') return;

        const slideCount = this.querySelectorAll('.swiper-slide').length;
        const autoplay = this.dataset.autoplay === 'true';
        const autoplayInterval =
          parseInt(this.dataset.autoplayInterval, 10) || 5000;
        const speed = parseInt(this.dataset.speed, 10) || 500;

        this.swiper = new Swiper(container, {
          loop: slideCount > 1,
          speed,
          observer: true,
          observeSlideChildren: true,
          grabCursor: true,
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          autoHeight: true,
          a11y: {
            enabled: true,
            slideLabelMessage: '{{index}} of {{slidesLength}}',
          },
          pagination:
            slideCount > 1
              ? {
                  el: this.querySelector('.banner-carousel__pagination'),
                  clickable: true,
                }
              : false,
          autoplay:
            autoplay && slideCount > 1
              ? {
                  delay: autoplayInterval,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
        });
      }

      disconnectedCallback() {
        if (this.swiper) this.swiper.destroy(true, true);
      }

      updateSwiperHeight() {
        if (this.swiper) this.swiper.updateAutoHeight(0);
      }
    },
  );
}
